// extracted by mini-css-extract-plugin
export default {"fs":"_65c511f54b f933bbf585"};